import axios from 'axios';

const API = axios.create({
 baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
 withCredentials: true
});

API.interceptors.request.use((config) => {
 const token = localStorage.getItem('app-token');
 if (token) {
 config.headers['x-auth-token'] = token;
 }
 return config;
});

API.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // user not authorized
      localStorage.removeItem('app-token');
      localStorage.removeItem('app-user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;
